<template>
  <b-navbar-nav>
    <b-nav-item href="#" class="nav-margin" v-if="agentMenu" to="/agent/inbound">{{$t("navigation.inbound")}}</b-nav-item>
    <b-nav-item href="#" class="nav-margin" v-if="agentMenu" to="/agent/shipmentplan">{{$t("navigation.shipment")}}</b-nav-item>
    <b-nav-item href="#" class="nav-margin" v-if="sellerMenu" to="/seller/item/registration">{{$t("navigation.productRegistration")}}</b-nav-item>
    <b-nav-item href="#" class="nav-margin" v-if="sellerMenu" to="/seller/inbound/confirmation">{{$t("navigation.inboundCondition")}}</b-nav-item>
    <b-nav-item href="#" class="nav-margin" v-if="agentMenu || sellerMenu" to="/common/merchandise/management">{{$t("navigation.management")}}</b-nav-item>
    <b-nav-item href="#" class="nav-margin" v-if="agentMenu || sellerMenu" to="/common/shipment/request">{{$t("navigation.shipmentCost")}}</b-nav-item>
    <!-- <b-nav-item-dropdown class="nav-margin" right v-if="enableTool" text="インボイス"> -->
    <b-nav-item-dropdown class="nav-margin" right v-if="agentMenu" text="インボイス">
      <div><b-dropdown-item class="gray-dark" to="/invoice/main">インボイス</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/invoice/master/procuct">商品マスタ</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/invoice/master/maker">メーカーマスタ</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/invoice/master/category">カテゴリマスタ</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/invoice/master/mapping">マッピング情報</b-dropdown-item></div>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown class="nav-margin" right v-if="agentMenu || sellerMenu" :text="$t('navigation.analysis')">
      <div><b-dropdown-item class="gray-dark" to="/common/analysis/sales">{{$t("navigation.analysisSales")}}</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/common/analysis/history">{{$t("navigation.analysisHistory")}}</b-dropdown-item></div>
      <div><b-dropdown-item v-if="agentMenu" class="gray-dark" to="/common/analysis/inbound">ポイント</b-dropdown-item></div>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown class="nav-margin" right v-if="agentMenu || sellerMenu" :text="$t('navigation.other')">
      <div><b-dropdown-item class="gray-dark" to="/other/deposit">{{$t("navigation.deposit")}}</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/other/slcusrequest">{{$t("navigation.billing")}}</b-dropdown-item></div>
      <div><b-dropdown-item v-if="agentMenu" class="gray-dark" to="/other/slcusupload">SLCUS請求一括登録</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/other/usreturnedgoodscustody">{{$t("navigation.returnOrStrageProduct")}}</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/other/payment">{{$t("navigation.payment")}}</b-dropdown-item></div>
      <div><b-dropdown-item v-if="agentMenu" class="gray-dark" to="/other/custom">関税</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" to="/other/invoice">{{$t("navigation.invoiceOutput")}}</b-dropdown-item></div>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown class="nav-margin" right :text="$t('navigation.masterManagement')">
      <div><b-dropdown-item class="gray-dark" v-if="agentMenu" to="/master/seller/registration">{{$t("navigation.memberRegistration")}}</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" v-if="agentMenu" to="/master/seller/list">{{$t("navigation.memberReference")}}</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" v-if="agentMenu || sellerMenu" to="/master/shippingfee/list">{{$t("navigation.shippingFeeMaster")}}</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" v-if="enableTool" to="/master/management/changesku">SKU変更</b-dropdown-item></div>
      <div><b-dropdown-item class="gray-dark" v-if="enableTool" to="/master/chatai/display">チャット</b-dropdown-item></div>
    </b-nav-item-dropdown>
    <b-nav-item v-if="enableTool"><b-button size="sm" href="#" variant="danger">{{$t("navigation.analyticsTools")}}</b-button></b-nav-item>
  </b-navbar-nav>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: ['agentMenu', 'sellerMenu', 'enableTool'],
};
</script>

<style scoped>
.gray-dark {
  background-color: #343a40;
  color: hsla(0, 0%, 100%, .5);
}
.active {
  color: white;
}
</style>

<style>
.nav-margin a {
    margin-top: 0.3rem;
}
a.dropdown-item.gray-dark {
    margin-top: 0;
}
.dropdown-menu.dropdown-menu-right.show {
    transform: translate(0, -0.3rem);
}

.dropdown-menu {
  padding-top: 0px;
  padding-bottom: 0px;
}
.dropdown-item:hover {
  color: whitesmoke;
}
.dropdown-item:last-child {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.dropdown-item:first-child {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
</style>